export default __webpack_public_path__ + "4c5d7d1ef9067dd23bee406906f386ec.png";